import {ApiProperty} from "@nestjs/swagger";
import { MaxLength, Matches, IsOptional} from "class-validator";
import { LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';
import { TransactionDto } from "./transactions.dto";

export class RequestDto {
    
    @ApiProperty()
    requestId: number;

    // @ApiProperty()
    // visitorCode:string;

    @ApiProperty()
    visitType: string;

    @ApiProperty()
    employeeName: string;

    @ApiProperty()
    employeeCode: number;

    @ApiProperty()
    department: string;

    @ApiProperty()
    visitorName: any;

    @ApiProperty()
    visitorCard: string;

    @ApiProperty()
    visitorEmail: string;

    @ApiProperty()
    visitorMobileNumber: string;

    @ApiProperty()
    aadharNumber: string;

    @ApiProperty()
    visitorAddress: string;

    @ApiProperty()
    visitorArrivalDate: Date;

    @ApiProperty()
    visitorDepartureDate: Date;

    @ApiProperty()
    purposeOfVisit: string;

    @ApiProperty()
    whomMeet: string;

    @ApiProperty()
    transportation: string;

    @ApiProperty()
    vehicleNumber: string;

    @ApiProperty()
    driverName: string;

    @ApiProperty()
    statusByHod: LeaveApprovalStatusEnum;
    
    @ApiProperty()
    statusByHr: LeaveApprovalStatusEnum;

    @ApiProperty()
    rejectionReason: string;

    @ApiProperty()
    vaccination: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    @IsOptional()
    pastTransactios :TransactionDto[];
}